const VegetarianSVG = ({color, iconSize = 24}) => (
    <svg width={iconSize} height={iconSize} viewBox="6 3 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.9833 7.5L12.268 17.188H12.2152L7.5 7.5" stroke={`${color}`} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default VegetarianSVG;